/**Obsahuje nastavení pro šifrování.*/
export interface IEncryptionSettings {
    /**
     * Název algoritmu dle specifikace JWK.
     * http://www.w3.org/TR/WebCryptoAPI/#jwk-mapping-alg
     * https://tools.ietf.org/html/rfc7518#appendix-A.2
     */
    algorithmName: string;
}
